module.exports = __webpack_public_path__ + "static/media/aq.4b2c7d76.svg";